export default __webpack_public_path__ + "static/media/tavi_dance.9e07fd0d.gif";